import React from 'react'
import './Warning.css';

const Warning = ({ setIsError }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-warning-box">
                <div className='warning'>
                    You've Reached Your Limit
                </div>
                <p className='warning-p'>You've used all your available points. To continue accessing our services and get expert legal assistance, please purchase a new plan or add more points to your account.</p>
                <div className="modal-btn">
                    <button onClick={() => setIsError(false)} className="close-warning-button">Close</button>
                </div>
            </div>
        </div>
    )
}

export default Warning
